// extracted by mini-css-extract-plugin
module.exports = {"dropzoneContainer":"FileUpload_dropzoneContainer__3ka-q","isSmall":"FileUpload_isSmall__2g4po","smdropzone":"FileUpload_smdropzone__2B0k6","dropzone":"FileUpload_dropzone__2193T"};